import { css } from 'linaria';

export const questionAccordion = css`
  && {
    width: 877px;

    @media (--to-desktop) {
      width: 100%;
    }
  }
`;

export const questionContainer = css`
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.12px;
  color: var(--text-primary);

  P {
    margin: 0 0 8px 0;
  }

  &:not(:last-child) {
    margin-bottom: 8px;
  }

  ul {
    padding: 0 0 0 24px;
    margin: 0;

    li {
      position: relative;
      margin-bottom: 8px;
      white-space: break-spaces;
    }
  }

  & a {
    color: var(--text-primary);
  }

  & a:hover,
  & a:active {
    color: var(--text-primary);
  }
`;
